<template>
  <div class="home">
    <vue-headful
    title="Descubra como melhorar o atendimento em sua loja virtual!"
    description="Descubra como melhorar o atendimento em sua loja virtual!"
    />
    <div v-show="flgPosicaoInicioMeioFim=='inicio'">

      <div class="text-center  pb-sm-5 pb-3">
        <a href="https://www.lojavirtual.com.br"><img src="@/assets/logo_lojavirtual_branca.png"  /></a>
      </div>

      <div class="row no-gutters" >
        <div class="col col-lg-6 offset-lg-3">
          <section class="">

            <div class="container "     >
              <div >
                <div :style="{backgroundImage: 'url(' + require('@/assets/conversao_cliente.jpg')  + ')'}" class="page-holder bg-cover">

                </div>
              </div>

              <div class="text-center shadow p-3 p-sm-5 mb-5 bg-white rounded  ml-sm-3 mr-sm-3 pergunta" style="z-index:10; position:relative">
                <h2>Que tal analisar seu atendimento?</h2>
                <!-- <iframe width="560" height="315" src="https://www.youtube.com/embed/pgsV7r5sf1U" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->
                <img class="pb-4" src="@/assets/home.jpg" style="width:80%" />
                <div class="d-flex  justify-content-center pb-3">
                  <div style="max-width:600px">
                    Fazemos <b>alguns perguntas</b> sobre o <b>atendimento</b>, e através de <b>suas respostas</b>, comparamos com a média mundial e te falamos se você <b>está indo bem</b> e o que <b>ainda pode melhorar</b>.
                  </div>
                </div>
                <div>
                  <a href="#"  @click.prevent="flgPosicaoInicioMeioFim = 'meio'; next();"  class="btn btn-success my-2 btn-lg mr-1 mr-sm-3" ><b-icon icon="hand-thumbs-up" ></b-icon> Analisar meu Atendimento</a>
                </div>
                <!-- {{arr_resp}} -->
                <!-- {{arr_questionario}} -->
              </div>

            </div>
          </section>

        </div>


      </div>
    </div>
    <div v-show="flgPosicaoInicioMeioFim=='meio'">

      <div class="text-center  pb-sm-5 pb-3">
        <a href="https://www.lojavirtual.com.br"><img src="@/assets/logo_lojavirtual_branca.png"  /></a>
      </div>

      <div class="row no-gutters" >
        <div class="col col-lg-6 offset-lg-3">
          <section class="">
            <div class="text-center pt-sm-5 pb-1 pt-1">
              <div class="progress mx-auto" style="width:60%">
                <div class="progress-bar" role="progressbar" :style="{width: ((10+percent*0.9))+'%'}" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">{{percent}}%</div>
              </div>
            </div>
            <div class="container " v-for="(q, index) in arr_questionario"      >
              <div v-show="q.flg_visible">
                <div :style="{backgroundImage: 'url(' + q.img + ')'}" class="page-holder bg-cover">
                  <img :src="q.img" style="display:none" />
                </div>
              </div>

              <transition name="slide-fader">
                <div class="text-center shadow p-3 p-sm-5 mb-5 bg-white rounded  ml-sm-3 mr-sm-3 pergunta" style="z-index:10; position:relative" v-show="q.flg_visible">
                  <div class="lead text"><h5 class=" text-center pb-3" style="color:#444" v-html="q.pergunta"></h5></div>
                  <div style="min-height:90px; display:flex; justify-content:center; align-items:center" class="mb-5 listaRespostas"  >
                    <transition-group name="gslide-fader" tag="div">
                      <div  v-for="(resp,ind) in q.resposta" class=" text-center  respostas "  v-if="resp.flg_visible" :key="ind" >
                        <h3 class="">"<span  v-html="resp.texto"></span>"</h3>
                      </div>
                    </transition-group>
                  </div>
                  <div style="min-height:90px">
                    <div class="buttonsRespostaInside">
                      <transition name="btslide-fader">
                        <div class="buttonsResposta" v-show="showButtonsResposta">
                          <a href="#"  @click.prevent="next_sub_item(false)"  class="btn btn-primary my-2 btn-lg mr-1 mr-sm-3" ><b-icon icon="hand-thumbs-down" ></b-icon> Falso</a>
                          <a href="#"  @click.prevent="next_sub_item(true)"  class="btn btn-primary my-2 btn-lg" ><b-icon icon="hand-thumbs-up" ></b-icon> Verdadeiro</a>
                        </div>

                      </transition>
                    </div>
                  </div>

                  <!-- {{arr_resp}} -->
                  <!-- {{arr_questionario}} -->
                </div>
              </transition>

            </div>

          </section>

        </div>


      </div>
    </div>
    <img src="@/assets/fundo_lv.jpg" style="display:none" />
    <transition name="slide-fader2">
      <div v-show="flgPosicaoInicioMeioFim =='fim'">
        <div class="text-center  pb-sm-5 pb-3">
          <a href="https://www.lojavirtual.com.br"><img src="@/assets/logo_lojavirtual_branca.png"  /></a>
        </div>
        <div :style="{backgroundImage: 'url(' + require('@/assets/fundo_lv.jpg') + ')'}" class="page-holder bg-cover">
        </div>


        <div class="row no-gutters respostasFinal" >
          <div class="col col-lg-6 offset-lg-3">
            <div class="container pr-1 pl-1 pr-sm-3 pl-sm-3 ">
              <div class="text-center shadow p-2 p-sm-5 mb-5 bg-white rounded  ml-1 mr-1 ml-sm-1  ml-sm-3 mr-sm-3" style="z-index:10; position:relative">
                <b>Veja os resultados da análise de seu atendimento!</b>

                <div class="card mb-4 " style="position:relative" v-for="(q, index) in arr_sugestoes" >
                  <div style="position:relative" class="d-flex flex-md-row  box-shadow h-md-250 align-items-start ">
                    <div class="card-body pr-3 pl-3 pr-sm-4 pl-sm-4">
                      <h4 class="text-left">{{q.titulo}}</h4>
                      <div class="progress mb-3"  :style="[!q.flg_respondido ? {'filter': 'blur(6px)  grayscale(1)'}:{}]">
                        <div class="progress-bar progress-bar-success" :class="{'bg-danger':q.nota>0&&q.nota<60,'bg-warning':q.nota>=60&&q.nota<80,'bg-success':q.nota>=80}" role="progressbar" aria-valuenow="40"
                          aria-valuemin="0" aria-valuemax="100" :style="{width: (q.nota)+'%'}">
                          Nota {{q.nota/10}} em 10
                        </div>
                      </div>
                      <div class="descricaoItem">
                        <div v-if="!q.flg_respondido" >
                          <a href="#"  @click.prevent="tipo_atual = index; start(); "  class="btn btn-success my-2 btn-lg mr-1 mr-sm-3" ><b-icon icon="hand-thumbs-up" ></b-icon> Realizar Teste</a>

                        </div>
                        <h5  v-if="q.flg_respondido" class="text-left">{{q.info_final.titulo}}</h5>
                        <div   v-if="q.flg_respondido" class="text-left" v-html="q.info_final.descricao_final">
                        </div>

                      </div>
                    </div>
                    <img  :style="[!q.flg_respondido ? {'filter': 'blur(6px) grayscale(1)'}:{}]" class="pt-4 card-img-right flex-auto d-none d-md-block" style="width:300px; object-fit: contain;" :src="arr_sugestoes[index].img" alt="Card image cap">
                  </div>



                </div>

                <h4>O que achou? Gostou? Dê sua nota</h4>
                <div class="d-flex  justify-content-center ">
                  <star-rating :show-rating="false" :increment="0.5" @rating-selected="setRating"  v-model="rating"></star-rating>
                </div>


              </div>

            </div>

          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import db from "@/firebase/init";
import firebase from "firebase";

import StarRating from 'vue-star-rating'
export default {
  name: 'Home',
  components: {
    StarRating
  },
  methods: {
    setRating:function(e)
    {
      if(this.uid != null)
      {
        console.log("AA");
        var dat =
        {

            data: new Date(),
          nota: e
        };
        db.collection('nota').doc(this.uid).set(dat).then(function(docRef) {
          console.log("nota escrita: ");
        })
        .catch(function(error) {
          console.error("Error nota escrita: ", error);
        });
      }

    },
    next_sub_item:function(flg_resposta)
    {
      this.arr_questionario[this.currentIndex].resposta[this.currentSubIndex].flg_resposta = flg_resposta;
      this.inner_play();
    },
    inner_play: function()
    {
      if(this.currentSubIndex != this.arr_questionario[this.currentIndex].resposta.length-1)
      {

        firebase.analytics().logEvent('sub_item_played_'+this.currentSubIndex, { name: 'item'+this.currentSubIndex});
        this.showButtonsResposta = false;

        if(this.currentSubIndex>=0)
        {
          this.arr_questionario[this.currentIndex].resposta[this.currentSubIndex].flg_visible = false;
        }
        this.currentSubIndex++;
        this.arr_questionario[this.currentIndex].resposta[this.currentSubIndex].flg_visible = true;
        setTimeout(() =>
        {

          this.showButtonsResposta = true;
        },1000);
      }
      else {
        this.next();
      }


    },
    calcula_nota: function()
    {
      if(this.uid != null)
      {
        var total = 0;
        //conta total respondido
        for (var key in this.arr_sugestoes)
        {
          if(this.arr_sugestoes[key].flg_respondido)
          {
            total++;
          }
        }

        var arr_resp =
        {
          data: new Date(),
          etotal:total,
          resp: this.arr_sugestoes
        };
        db.collection('dados').doc(this.uid).set(arr_resp).then(function(docRef) {
          console.log("dados escritos: ");
        })
        .catch(function(error) {
          console.error("Error dados escrita: ", error);
        });
      }

      for (var key in this.arr_sugestoes)
      {
        var nota = 0;
        var nota_maxima = 0;
        var nota_minima = 0;
        var nota_final = 0;
        for(var i=0;i<this.arr_questionario.length; i++ )
        {

          for(var j=0;j<this.arr_questionario[i].resposta.length; j++ )
          {
            var resp = this.arr_questionario[i].resposta[j];
            if(resp.grupo == key)
            {
              if(resp.flg_resposta)
              {
                nota+=resp.valor;
              }
              if(resp.valor <0)
              {
                nota_minima += resp.valor;
              }
              if(resp.valor > 0)
              {
                nota_maxima += resp.valor;
              }

            }
          }
        }
        if(nota_maxima == 0)
        {
          nota_maxima = 1;
        }
        console.log("NOTA",nota_minima,nota_maxima,nota );
        nota_final = Math.floor((Math.abs(nota_minima)+nota)/(Math.abs(nota_minima)+nota_maxima)*100);
        //nota_final = 90;


        this.arr_sugestoes[key].nota = Math.floor(30+nota_final*0.7);
        var info_final = 0;
        if(nota_final <= 50)
        {
          info_final = 0;
        }
        else if(nota_final <= 75)
        {
          info_final = 1;
        }
        else {
          info_final = 2;
        }

        this.arr_sugestoes[key].info_final = this.arr_sugestoes[key].arr_info[info_final];
        this.arr_sugestoes[key].info_final.descricao_final = this.arr_sugestoes[key].oquee + this.arr_sugestoes[key].info_final.descricao;

      }
    },
    start:function()
    {
      for(var i=0;i<this.arr_questionario.length; i++ )
      {
        this.arr_questionario[i].flg_visible = false;
      }
      this.flgPosicaoInicioMeioFim = 'meio';
      this.currentIndex = -1;
      this.currentSubIndex = -1;
      this.next();
    },
    next: function ()
    {
      this.calcula_nota();
      var index = this.currentIndex;
      if(index != this.arr_questionario.length-1)
      {
        this.currentSubIndex = -1;
        this.currentIndex = index*1+1;

        if(index>=0)
        {
          this.arr_questionario[index].flg_visible = false;

        }

        if(this.arr_questionario[index*1+1*1].grupo != this.tipo_atual)
        {
          this.next();
        }
        else {

          this.arr_questionario[index*1+1*1].flg_visible = true;
          this.inner_play();

        }

      }
      else
      {
        firebase.analytics().logEvent('visualizou_dica2', { name: this.tipo_atual});
        this.arr_sugestoes[this.tipo_atual].flg_respondido = true;
        this.calcula_nota();
        this.flgPosicaoInicioMeioFim = 'fim';
      }



    }
  },
  computed: {
    // a computed getter
    percent: function ()
    {
      var maximo = 1;
      var pos_atual = 0;
      var cont = 0;

      for(var i=0;i<this.arr_questionario.length; i++ )
      {
        for(var j=0;j<this.arr_questionario[i].resposta.length; j++ )
        {

          if(this.currentIndex == i && this.currentSubIndex == j)
          {
            pos_atual = cont;
          }
          if(this.arr_questionario[i].grupo == this.tipo_atual)
          {
            cont++;
            maximo = cont;
          }
        }
      }


      return Math.floor(pos_atual/maximo*100);
    }
  },
  data: function ()
  {
    return {
      rating:4,
      isAnonymous:false,
      uid:null,
      tipo_atual:'responder_rapido',
      showButtonsResposta:false,
      flgPosicaoInicioMeioFim:'inicio',
      currentIndex:-1,
      currentSubIndex:-1,
      arr_sugestoes:{
        responder_rapido:{
          oquee:"",
          img:require("@/assets/resposta_rapida.jpg"),
          titulo:"Velocidade de resposta",
          nota:66,
          flg_respondido:false,
          info_final:'',
          arr_info:[
            {titulo:"A velocidade de atendimento não está boa",descricao:"Embora <b>alguns clientes</b> ainda <b>estejam bem</b> com um tempo de <b>resposta de 24 horas</b>, pesquisas revelam que <b>88% dos clientes</b> esperam uma resposta por e-mail é de <b>até 1 hora</b>.<BR /> Saiba mais <a target='_blank' href='https://www.lojavirtual.com.br/blog/saiba-como-reduzir-o-tempo-de-resposta-nos-atendimentos-aos-clientes/'>como responder mais rápidamente seus clientes</a>."},
            {titulo:"Você pode melhorar a velocidade de atendimento",descricao:"Embora <b>alguns clientes</b> ainda <b>estejam bem</b> com um tempo de <b>resposta de 24 horas</b>, pesquisas revelam que <b>88% dos clientes</b> esperam uma resposta por e-mail é de <b>até 1 hora</b>.<BR /> Saiba mais <a target='_blank'  href='https://www.lojavirtual.com.br/blog/saiba-como-reduzir-o-tempo-de-resposta-nos-atendimentos-aos-clientes/'>como responder mais rápidamente seus clientes</a>."},
            {titulo:"Parabéns! Você responde seus clientes muito rápido!",descricao:"Embora <b>alguns clientes</b> ainda <b>estejam bem</b> com um tempo de <b>resposta de 24 horas</b>, pesquisas revelam que <b>88% dos clientes</b> esperam uma resposta por e-mail é de <b>até 1 hora</b>.<BR /> Saiba mais <a target='_blank'  href='https://www.lojavirtual.com.br/blog/saiba-como-reduzir-o-tempo-de-resposta-nos-atendimentos-aos-clientes/'>como responder mais rápidamente seus clientes</a>. "}]
          },
          reclamacoes:{
            oquee:"Somente <b>1</b> a <b>cada 25</b> clientes instatisfeitos reclama <b>diretamente com você</b>. E eles esperam 4 coisas: <BR />- <b>Pedido de Desculpas</b>, <BR />- <b>Solução do problema</b>, <BR />- <b>Agilidade</b><BR /> - ..e as vezes <b>Compensação</b>.<BR />Clientes esperam que seu <b>problema seja resolvido</b> pelo <b>mesmo canal</b> que estão pedindo ajuda. As <b>reclamações dos clientes</b> são uma <b>maneira incrível</b> de <b>coletar feedback</b> sobre áreas que precisam ser melhoradas. <BR /> Saiba mais <a href='https://www.lojavirtual.com.br/blog/saiba-como-agir-de-maneira-eficiente-com-reclamacoes-de-clientes/' target='_blank' >como lidar com reclamações de seus clientes</a>.", //Uma reclamação de cliente <b>destaca um problema</b>, seja um problema com seu produto, funcionários ou processos internos, e ao <b>ouvir esses problemas</b> diretamente de seus clientes você pode <b>investigar</b> e <b>melhorar</b> para <b>evitar futuras reclamações</b>. E o <b>mais impressionante</b>, é que se a reclamção do cliente for <b>resolvida de forma eficiente</b>, ele tem mais chances de <b>retornar e gastar mais</b> com seus serviços ou produtos! <BR />
            img:require("@/assets/cliente_bravo.jpg"),
            titulo:"Reclamações de clientes",
            nota:66,
            flg_respondido:false,
            info_final:'',
            arr_info:[
              {titulo:"Você não está lidando bem com as reclamações",descricao:""},
              {titulo:"Você pode melhorar a forma que lida com reclamações",descricao:""},
              {titulo:"Parabéns! Você lida muito bem com reclamações!",descricao:""}]
            }
            ,
            feedback:{
              oquee:"O <b>feedback</b> dos seus clientes é <b>importante</b> por vários motivos:<BR /> - Te ajuda a <b>melhorar o produto/serviço</b>. <BR /> - Compradores <b>confiam</b> em marcas com <b>muitos depoimentos reais</b>.<BR /> - <b>Avaliações Online</b> são importantes para os <b>mecanismos de busca</b>.<BR />As <b>avaliações</b> não fornecem <b>apenas feedback</b> que pode ajudar a <b>melhorar seu serviço</b>. Eles também podem <b>aumentar</b> o tamanho de <b>sua empresa</b>, aumentando sua <b>presença online</b>. <BR /> Saiba mais <a href='https://www.lojavirtual.com.br/blog/como-lidar-com-os-feedbacks-dos-clientes/' target='_blank' >como lidar com feedback de seus clientes</a>.", //Uma reclamação de cliente <b>destaca um problema</b>, seja um problema com seu produto, funcionários ou processos internos, e ao <b>ouvir esses problemas</b> diretamente de seus clientes você pode <b>investigar</b> e <b>melhorar</b> para <b>evitar futuras reclamações</b>. E o <b>mais impressionante</b>, é que se a reclamção do cliente for <b>resolvida de forma eficiente</b>, ele tem mais chances de <b>retornar e gastar mais</b> com seus serviços ou produtos! <BR />
              img:require("@/assets/feedback2.jpg"),
              titulo:"Feedback dos Clientes",
              nota:66,
              flg_respondido:false,
              info_final:'',
              arr_info:[
                {titulo:"Você não está ouvindo seus clientes",descricao:""},
                {titulo:"Você pode ouvir mais os seus clientes",descricao:""},
                {titulo:"Parabéns! Você ouve seus clientes!",descricao:""}]
              }
            },
            arr_resp:{
              //"responder_rapido": { "cont": 6, "soma": 2,"conhecimento":2 }, "disponibilidade": { "cont": 6, "soma": 3,"conhecimento":0 }, "ouvir": { "cont": 1, "soma": 0,"conhecimento":2 }, "proatividade": { "cont": 4, "soma": 0,"conhecimento":1 }, "escuta": { "cont": 3, "soma": 2,"conhecimento":0 }, "omnicanal": { "cont": 2, "soma": 1,"conhecimento":1 }
            },
            arr_questionario:[
              {grupo:"responder_rapido",  vr_selecionado:-1, tipo:"radio", flg_visible:false,
              pergunta:"Sobre o tempo <b>você leva</b> para <b>responder e-mails</b> de seus clientes.<BR /> A frase abaixo é <b>Falsa</b> ou <b>Verdadeira</b>?",img:require("@/assets/atendimento_cliente.jpg"),
              resposta:[
                {grupo:"responder_rapido",texto:"<b>Alguns</b> e-mails eu respondo em <b>mais de 3 dias</b>.", flg_visible:false, valor:-10, flg_resposta:false},
                {grupo:"responder_rapido",texto:"<b>Alguns</b> e-mails eu respondo <b>em 2-3 dias</b>.", flg_visible:false, valor:-2, flg_resposta:false},
                {grupo:"responder_rapido",texto:"<b>Alguns</b> e-mails eu respondo <b>em 1 dia</b>.", flg_visible:false, valor:5, flg_resposta:false},
                {grupo:"responder_rapido",texto:"<b>Alguns</b> e-mails eu respondo <b>em 1 hora</b> ou assim que eu vejo.",flg_visible:false,  valor:10, flg_resposta:false},



                {grupo:"responder_rapido",texto:"<b>Raramente</b> eu consigo responder e-mails em <b>1 hora</b>.", flg_visible:false, valor:-7, flg_resposta:false},
                {grupo:"responder_rapido",texto:"<b>Raramente</b> eu consigo responder e-mails em <b>menos de 24 horas</b>.", flg_visible:false, valor:-15, flg_resposta:false},
                {grupo:"responder_rapido",texto:"Eu <b>não sei</b> ao certo <b>quanto tempo demora</b> para eu responder e-mails.", flg_visible:false, valor:-10, flg_resposta:false},
                {grupo:"responder_rapido",texto:"<b>Raramente</b> eu demoro <b>3 dias ou mais</b> para responder.", flg_visible:false, valor:5, flg_resposta:false},
              ]},
              {grupo:"reclamacoes", vr_selecionado:-1, tipo:"radio", flg_visible:false,
              pergunta:"Se um cliente abre uma <b>reclamação</b> no <b>ReclameAqui</b> contra seu serviço, <b>o que você faz?</b>",img:require("@/assets/reclamacao.jpg"),
              resposta:[
                {grupo:"reclamacoes",texto:"Costumo <b>respondê-lo</b> em <b>menos de 3 dias</b>",flg_visible:false,  valor:5, flg_resposta:false},
                {grupo:"reclamacoes",texto:"Costumo <b>respondê-lo</b> em <b>menos de 24 horas</b>",flg_visible:false,  valor:20, flg_resposta:false},

                {grupo:"reclamacoes",texto:"<b>Raramente</b> eu respondo o cliente <b>no mesmo dia</b>",flg_visible:false,  valor:-6, flg_resposta:false},
                {grupo:"reclamacoes",texto:"<b>Raramente</b> eu respondo o cliente em <b>menos de 3 dias</b>",flg_visible:false,  valor:-15, flg_resposta:false},
                {grupo:"reclamacoes",texto:"<b>Costumo</b> fazer uma <b>ligação telefônica</b> para o cliente.",flg_visible:false,  valor:10, flg_resposta:false},
                {grupo:"reclamacoes",texto:"<b>Raramente</b> faço uma <b>ligação telefônica</b> para o cliente.",flg_visible:false,  valor:-15, flg_resposta:false},
                {grupo:"reclamacoes",texto:"Envio uma <b>resposta</b> no próprio <b>ReclameAqui</b> perguntando sobre o problema",flg_visible:false,  valor:-5, flg_resposta:false},
                {grupo:"reclamacoes",texto:"Envio uma  <b>resposta</b> no próprio <b>ReclameAqui</b> pedindo para o <b>cliente entrar em contato</b> conosco.",flg_visible:false,  valor:-10, flg_resposta:false},
                {grupo:"reclamacoes",texto:"<b>Ignoro</b>, pois <b>não devo explicações</b> para o ReclameAqui",flg_visible:false,  valor:-20, flg_resposta:false},

              ]},
              {grupo:"responder_rapido", vr_selecionado:-1, tipo:"radio", flg_visible:false,
              pergunta:"Sobre a <b>fila/ordem</b> de <b>atendimento</b> de seus clientes.<BR /> A frase abaixo é <b>Falsa</b> ou <b>Verdadeira</b>?",img:require("@/assets/fila_atendimento.jpg"),
              resposta:[
                {grupo:"responder_rapido",texto:"Eu <b>não diferencio</b> meus clientes, <b>todos</b> entram na <b>mesma fila</b> de atendimento.",flg_visible:false,  valor:-5, flg_resposta:false},
                {grupo:"responder_rapido",texto:"<b>Quase nunca</b> ficam  clientes <b>esperando</b> para serem atendidos.", flg_visible:false, valor:5, flg_resposta:false},
                {grupo:"responder_rapido",texto:"Os <b>clientes mais importantes</b> são atendidos <b>primeiro</b>", flg_visible:false, valor:5, flg_resposta:false},
                {grupo:"responder_rapido",texto:"<b>As vezes</b>, alguns clientes demoram <b>mais de 30 minutos</b> para serem atendidos no meu <b>chat / Whatsapp</b>.", flg_visible:false, valor:-2, flg_resposta:false},
              ]},

              {grupo:"reclamacoes", vr_selecionado:-1, tipo:"radio", flg_visible:false,
              pergunta:"Sobre <b>reclamação pública</b> no <b>Facebook</b> ou <b>Instagram</b>. A frase abaixo é <b>Falsa</b> ou <b>Verdadeira</b>",img:require("@/assets/reclamacao_social.png"),
              resposta:[

                {grupo:"reclamacoes",texto:"Costumo <b>apagar imediatamente</b>, para que <b>outros não vejam</b>",flg_visible:false,  valor:-5, flg_resposta:false},
                {grupo:"reclamacoes",texto:"Costumo  <b>entrar em contato</b> com o cliente <b>pelo Facebook ou Instagram</b>",flg_visible:false,  valor:10, flg_resposta:false},
                {grupo:"reclamacoes",texto:"Costumo  <b>ligar</b> para o cliente",flg_visible:false,  valor:15, flg_resposta:false},
                {grupo:"reclamacoes",texto:"Costumo  <b>mandar um e-mail</b> para o cliente",flg_visible:false,  valor:-5, flg_resposta:false},
                {grupo:"reclamacoes",texto:"Costumo  deixar uma <b>mensagem padrão</b> avisando que se ele precisar de ajuda <b>pode entrar em contato</b> conosco",flg_visible:false,  valor:-5, flg_resposta:false},
                {grupo:"reclamacoes",texto:"Costumo  <b>ignorar</b> as <b>reclamações</b> em <b>redes sociais</b>",flg_visible:false,  valor:-15, flg_resposta:false},

              ]},
              {grupo:"feedback", vr_selecionado:-1, tipo:"radio", flg_visible:false,
              pergunta:"Sobre a <b>avaliação de seu cliente</b> sobre <b>cada atendimento</b> seu. A frase abaixo é <b>Falsa</b> ou <b>Verdadeira</b>",img:require("@/assets/feedback.jpg"),
              resposta:[
                {grupo:"feedback",texto:"Clientes tem a possibilidade de <b>avaliar o atendimento</b> após serem atendidos.",flg_visible:false,  valor:10, flg_resposta:false},
                {grupo:"feedback",texto:"Após o <b>cliente efetuar um pedido</b>, eu pergunto <b>o que achou</b> da <b>compra</b>", flg_visible:false, valor:3, flg_resposta:false},
                {grupo:"feedback",texto:"Após o <b>o pedido chegar na casa</b> do cliente, eu pergunto <b>o que achou</b> do <b>produto</b>", flg_visible:false, valor:3, flg_resposta:false},
                {grupo:"feedback",texto:"<b>Frequentemente</b> eu avalio se os <b>clientes estão gostando</b> do atendimento.", flg_visible:false, valor:5, flg_resposta:false},
                {grupo:"feedback",texto:"<b>Raramente</b> envio <b>pesquisa</b> para meus clientes perguntando sobre o <b>atendimento</b>", flg_visible:false, valor:-3, flg_resposta:false},
                {grupo:"feedback",texto:"<b>Raramente</b> envio <b>pesquisa</b> para meus clientes perguntando sobre o <b>produto/serviço que compraram</b>", flg_visible:false, valor:-3, flg_resposta:false},
                {grupo:"feedback",texto:"<b>Geralmente</b> eu avalio o atendimento <b>somente</b> pelo número de <b>elogios/críticas</b> que recebemos.", flg_visible:false, valor:-5, flg_resposta:false},
                {grupo:"feedback",texto:"Tenho uma <b>área em meu site</b> com <b>depoimentos</b> verdadeiros <b>de clientes</b>.", flg_visible:false, valor:10, flg_resposta:false},
              ]}


            ]
          }
        },
        mounted: function () {

          firebase.analytics().logEvent('nota_calculada', { name: 'nota_calculada'});
          firebase.auth().signInAnonymously().catch((error) => {
            // Handle Errors here.
            var errorCode = error.code;
            var errorMessage = error.message;
            // ...
          });
          firebase.auth().onAuthStateChanged((user) => {
            if (user) {
              // User is signed in.
              console.log("LOGADO")
              this.isAnonymous = user.isAnonymous;
              this.uid = user.uid;
              var docRef = db.collection("nota").doc(this.uid);
              // Get a document, forcing the SDK to fetch from the offline cache.
              docRef.get().then((doc) => {
                // Document was found in the cache. If no cached document exists,
                // an error will be returned to the 'catch' block below.
                var doc_data = doc.data();
                this.rating = doc_data.nota;
              }).catch((error) => {
                console.log("Documento NOTA nao existe.", error);
              });
              // ...
            } else {
              // User is signed out.
              // ...
            }
            // ...
          });



          this.calcula_nota();
        }
      }
      </script>
      <style>
      .fadeText
      {
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
      }
      .page-holder {
        min-height: 100vh;
      }
      /* Enter and leave animations can use different */
      /* durations and timing functions.              */
      .slide-fade-enter-active {
        transition: all 0.5s ease;
      }
      .slide-fade-leave-active {
        display: none;
      }
      .listaRespostas
      {
        margin-left: 0px;
        padding-left: 0px;
        opacity: 1;
        transition:  all 0.5s ease;
        transition-delay: 1.8s;
      }
      .respostas
      {
        margin-left: 0px;
        padding-left: 0px;
        opacity: 1;
        transition:  all 0.5s ease;
        transition-delay: 0.4s;
      }
      .respostasFinal
      {
        margin-left: 0px;
        padding-left: 0px;
        opacity: 1;
        transition:  all 0.5s ease;
        transition-delay: 0.4s;
      }
      .buttonsResposta
      {
        margin-left: 0px;
        padding-left: 0px;
        opacity: 1;
        transition:  all 0.3s ease;

      }
      .buttonsRespostaInside
      {
        margin-left: 0px;
        padding-left: 0px;
        opacity: 1;
        transition:  all 0.5s ease;
        transition-delay: 2.8s !important;

      }
      .pergunta
      {
        margin-left: 0px;
        padding-left: 0px;
        opacity: 1;
        transition:  all 0.5s ease;

      }
      h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6
      {
        font-weight: 400 !important;
      }
      @media (max-width: 679px) {
        h4 {
          font-size:1.2rem !important;
          } /*1rem = 16px*/
        }


        .slide-fader, .slide-fader2 {
          transition: all 0.5s;
          transition-delay: 0.3s;
        }

        .slide-fader-enter-to .buttonsRespostaInside, .slide-fader-enter .buttonsRespostaInside, .slide-fader-before-enter .buttonsRespostaInside
        {
          transition-delay: 5.3s;
        }

        .slide-fader2-enter-to .respostasFinal, .slide-fader2-enter .respostasFinal, .slide-fader2-before-enter .respostasFinal
        {
          transition-delay: 1.3s;
        }
        .slide-fader2 .respostasFinal
        {
          transition: all 0.5s;
          transition-delay: 2.3s;

        }
        .slide-fader .listaRespostas
        {
          transition: all 0.5s;
          transition-delay: 2.3s;

        }
        .slide-fader-enter .listaRespostas, .slide-fader-enter .buttonsRespostaInside,   .slide-fader2-enter .respostasFinal
        {
          opacity: 0;
          transition: all 0.5s;
          transition-delay: 1.3s;

        }
        .slide-fader-enter, .gslide-fader-leave-to, .slide-fader-enter .buttonsRespostaInside
        /* .card-leave-active for <2.1.8 */ {
        opacity: 0;
        transform: scale(0.7);
      }
      .slide-fader-leave-to, .slide-fader-leave-to .listaRespostas, .slide-fader-lave-to .buttonsRespostaInside
      {
        display: none

      }
      .slide-fader-enter-to, .slide-fader-enter-to .listaRespostas, .slide-fader-enter-to .buttonsRespostaInside {
        opacity: 1;
        transform: scale(1);
      }

      .slide-fader-leave-active {
        /*position: absolute;*/
      }

      .slide-fader-move {
        opacity: 1;
        transition: all 0.3s;
      }
      .btslide-fader {
        transition: all 0.5s;

      }
      .btslide-fader-enter, .gslide-fader-leave-to
      /* .card-leave-active for <2.1.8 */ {
      opacity: 0;
      transform: scale(1);
    }
    .btslide-fader-leave-to
    {
      display: none

    }
    .btslide-fader-enter-to {
      opacity: 1;
      transform: scale(1);
    }

    .btslide-fader-leave-active {
      /*position: absolute;*/
    }

    .btslide-fader-move {
      opacity: 1;
      transition: all 0.3s;
    }

    .gslide-fader {
      transition: all 0.5s;
      transition-delay: 1.3s;

    }
    .gslide-fader-enter, .gslide-fader-leave-to
    /* .card-leave-active for <2.1.8 */ {
    opacity: 0;
    transform: scale(1);
  }
  .gslide-fader-leave-to
  {
    display: none

  }
  .gslide-fader-enter-to {
    opacity: 1;
    transform: scale(1);
  }

  .gslide-fader-leave-active {
    /*position: absolute;*/
  }

  .gslide-fader-move {
    opacity: 1;
    transition: all 0.3s;
    transition-delay: 1.3s;
  }


  .bg-cover {
    background:no-repeat center center fixed;
    background-size: cover !important;
    background-color: #333;
    position: fixed;
    min-width: 100vw;
    left: 0;
    top: 0;
    z-index: -10;

  }

  jumbotron {
    padding-top: 3rem;
    padding-bottom: 3rem;
    margin-bottom: 0;
    background-color: #fff;
  }
  @media (min-width: 768px) {
    .jumbotron {
      padding-top: 6rem;
      padding-bottom: 6rem;
    }
  }

  .jumbotron p:last-child {
    margin-bottom: 0;
  }

  .jumbotron-heading {
    font-weight: 300;
  }
  .vue-star-rating-rating-text
  {
    width: 20px;
  }
  .jumbotron .container {
    max-width: 40rem;
  }
  .descricaoItem b
  {
    font-weight:640;
  }
  footer {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }
  iframe, object, embed {
    max-width: 100%;
    max-height: 100%;
  }
  footer p {
    margin-bottom: .25rem;
    }</style>
